<template>
  <v-sheet>
    About Renedian
  </v-sheet>
</template>
<script>
export default {
  name: 'AboutRenedian',
  data: () => ({
    //
  }),
  created() {
    
  }
}
</script>